import { render } from "./Sidebar.vue?vue&type=template&id=dd1e5348&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=dd1e5348&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1e5348"]])

export default __exports__